// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4hta4qYox{display:flex;flex-direction:column;flex-grow:1}._4pyFu0pXx{flex-grow:1;overflow:auto;width:inherit;display:flex;flex-direction:column;box-sizing:border-box;transition:border-color .2s linear;-webkit-overflow-scrolling:touch}._4pyFu0pXx._3iUwf9sWx,._3iUwf9sWx ._4pyFu0pXx{padding-top:4px;margin-top:-4px}@media (max-width: 767px){html[data-supports-mobile=true] ._4pyFu0pXx{overflow:unset;height:auto}html[data-supports-mobile=true] ._6MHvvDPjx ._4pyFu0pXx{overflow:auto}}._2NatIqIzx{display:flex;z-index:1;flex:1 0 auto;flex-direction:column;height:100%;box-sizing:border-box;width:280px}@media (min-width: 1300px){._2NatIqIzx{width:300px}}@media (min-width: 1500px){._2NatIqIzx{width:320px}}._2NatIqIzx>:first-child,._2NatIqIzx>:last-child:not(._4pyFu0pXx):not(._2PPN9zR7x):not(._4hta4qYox){flex:0 0 auto}._2NatIqIzx._6vC3eK2xx._7Au2bGHYx>._2PPN9zR7x:after,._2NatIqIzx._6vC3eK2xx._7Au2bGHYx>._4pyFu0pXx:after{content:'';position:absolute;width:100%;height:100%;top:0;left:0;background-color:var(--gray-light3);opacity:0.7}._2PPN9zR7x{flex-grow:1}._4tNGcykux{display:none}._6vC3eK2xx ._4tNGcykux{display:block}._6vC3eK2xx{width:100%}._6vC3eK2xx ._4pyFu0pXx._7Au2bGHYx>._5BUBEsgkx{position:relative}._6gkkfHZBx{background-color:var(--secondary-panel)}@media (max-width: 767px){html[data-supports-mobile=true] ._6gkkfHZBx{display:none}}._6MHvvDPjx{overflow:hidden}._5BUBEsgkx{flex:1 0 auto;width:inherit;display:flex;flex-direction:column;box-sizing:content-box;transition:transform 200ms cubic-bezier(0.165, 0.84, 0.44, 1);transform:translateX(-32px)}._5BUBEsgkx._6gkkfHZBx{padding-top:0;padding-right:0;padding-bottom:0}._5BUBEsgkx._6vC3eK2xx{transform:translateX(0);box-sizing:border-box}._6MHvvDPjx ._5BUBEsgkx{transform:none}._46rAqYOax{max-width:800px;width:100%;margin-left:auto;margin-right:auto}body[data-outline] ._4pyFu0pXx:focus{outline:none;border-color:#4EA1E6}._6vC3eK2xx .RuI6smXgx{background-color:var(--surface-card)}._6gkkfHZBx ._4pyFu0pXx{transform:translateZ(1px);overflow-x:hidden;overflow-y:visible;-ms-overflow-style:-ms-autohiding-scrollbar}._6vC3eK2xx ._4pyFu0pXx{transform:none;overflow-x:hidden;overflow-y:visible;-ms-overflow-style:auto}body._23mqDTr6x ._6gkkfHZBx ._4pyFu0pXx{padding-right:100vw}body._23mqDTr6x ._6vC3eK2xx ._4pyFu0pXx{padding-right:0}@media (max-width: 767px){html[data-supports-mobile=true] ._3VcnY2xAx{display:none}html[data-supports-mobile=true] ._6MHvvDPjx{border-radius:0}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"full-height-column": "_4hta4qYox",
	"fullHeightColumn": "_4hta4qYox",
	"scroll-container": "_4pyFu0pXx",
	"scrollContainer": "_4pyFu0pXx",
	"has-header-area": "_3iUwf9sWx",
	"hasHeaderArea": "_3iUwf9sWx",
	"in-modal": "_6MHvvDPjx",
	"inModal": "_6MHvvDPjx",
	"page": "_2NatIqIzx",
	"vertical-tabs-container": "_2PPN9zR7x",
	"verticalTabsContainer": "_2PPN9zR7x",
	"in-primary": "_6vC3eK2xx",
	"inPrimary": "_6vC3eK2xx",
	"disabled": "_7Au2bGHYx",
	"notification": "_4tNGcykux",
	"page-content": "_5BUBEsgkx",
	"pageContent": "_5BUBEsgkx",
	"in-secondary": "_6gkkfHZBx",
	"inSecondary": "_6gkkfHZBx",
	"page-content-constrained": "_46rAqYOax",
	"pageContentConstrained": "_46rAqYOax",
	"white": "RuI6smXgx",
	"transitioning-to-secondary": "_23mqDTr6x",
	"transitioningToSecondary": "_23mqDTr6x",
	"in-hidden": "_3VcnY2xAx",
	"inHidden": "_3VcnY2xAx"
};
module.exports = exports;
